import React from 'react';
import PropTypes from 'prop-types';
import MarketAssumptions from './MarketAssumptionsTable';

class AssumptionsView extends React.Component {
  componentDidMount() {
    const { initializeSection, clientId, requestData, isAdviserArea, portalName } = this.props;

    document.title = `Definitions, Disclosures, Assumptions | ${portalName}`;

    initializeSection(clientId, isAdviserArea);
    requestData(clientId);
  }

  componentWillUnmount() {
    const { resetSection } = this.props;
    resetSection();
  }

  render() {
    const { assumptions, correlationMatrix } = this.props;

    return (
      <div id="Assumptions">
        <header>
          <h2>Definitions, Disclosures &amp; Assumptions</h2>
        </header>
        <div className="soft-widget">
          <h3>Capital Market Assumptions</h3>
          <div className="six columns">
            <MarketAssumptions assumptions={assumptions.slice(0, assumptions.length / 2)} />
          </div>
          <div className="six columns border-dashed-left">
            <MarketAssumptions assumptions={assumptions.slice(assumptions.length / 2)} />
          </div>
        </div>
        <div className="paragraphs">
          <div className="six columns">
            <h3>Standard Deviation</h3>
            <p>
              Standard deviation is used by investors to gauge the level of volatility in an
              investment. A risky investment will have a higher standard deviation, whereas a less
              risky investment will have a lower standard deviation.
            </p>
          </div>
          <div className="six columns">
            <h3>Projected Return</h3>
            <p>
              The projected return is calculated by taking a weighted average of each asset class
              and applying their respective average return using forward looking capital market
              assumptions.
            </p>
          </div>
        </div>
        <div className="soft-widget padded">
          <h3>Correlation Matrix</h3>
          <div className="twelve columns scroll adv-scrollbars">
            <table className="correlation-matrix">
              <thead>
                <th aria-label="Empty Header" />
                {correlationMatrix.map(assetClass => (
                  <th key={assetClass.AssetClassX}>
                    <span>{assetClass.AssetClassX}</span>
                  </th>
                ))}
              </thead>
              <tbody>
                {correlationMatrix.map(assetClass => (
                  <tr key={assetClass.AssetClassX}>
                    <td>{assetClass.AssetClassX}</td>
                    {assetClass.AssetClassCorrelations.map((correlation, index) => {
                      if (correlation.AssetClassY !== correlationMatrix[index].AssetClassX) {
                        throw 'The correlation matrix is not sorted';
                      }
                      return (
                        <td key={index}>
                          <span>{correlation.Correlation}</span>
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

AssumptionsView.defaultProps = {
  clientId: '',
};

AssumptionsView.propTypes = {
  initializeSection: PropTypes.func.isRequired,
  clientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  requestData: PropTypes.func.isRequired,
  isAdviserArea: PropTypes.bool.isRequired,
  assumptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  correlationMatrix: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  resetSection: PropTypes.func.isRequired,
  portalName: PropTypes.string.isRequired,
};

export default AssumptionsView;
